import ApiService from '@/services/api.service'

const DailyServiceLog = {
    getAll(parameter, addExtraParams = false) {
      const params = {
        PageSize: parameter.PageSize,
        PageNumber: parameter.PageNumber,
        PatientCode: parameter.PatientCode
      };

      if (addExtraParams) {
        // Add extra params , only for report listing
        params.ProgramCode = parameter.ProgramCode
        params.BillingTherapists = parameter.BillingTherapists
        params.SignedTherapists = parameter.SignedTherapists   
        params.Facilities = parameter.Facilities;
        params.DateFrom = parameter.DateFrom; 
        params.DateTo = parameter.DateTo;
        params.TherapiesCode = parameter.TherapiesCode;
        params.Show = parameter.Show;
        params.GroupBy = parameter.GroupBy;
        params.Source = parameter.Source;
        params.IncludeFiltersInReport = parameter.IncludeFiltersInReport;
      }
      return ApiService.getWithArray('/DailyServiceLog',params); 
    },
}
  
export default DailyServiceLog;